import { useEffect } from "react"
import GantChartWrapper from "./Gantt/GantChartWrapper"
import MonitoringDeepDive from "./MonitoringDeepDive"
import {
  cardToggle,
  cardsSelector,
  filterRefreshStatusCalendar,
  lastRunAsync,
} from "./MonitorSlice"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import { IMonitorCardInterface } from "../../util/interface"
import MonitorCard from "./MonitorCard"
import NewPipeLineDialog from "./NewPipeLineRun/NewPipeLineDialog"
import { Box } from "@mui/material"

export default function Monitor() {
  // Get the dispatch function from Redux to trigger actions
  const dispatch = useAppDispatch()

  // Select the card data from the Redux store using a custom selector
  const cards = useAppSelector(cardsSelector)

  const pipelines = cards.length > 0 ? cards[0]?.runs : 0

  // Use the useEffect hook to dispatch an asynchronous action to fetch the last run data
  // when the component mounts (empty dependency array means this runs once on mount)
  useEffect(() => {
    dispatch(lastRunAsync())
  }, [])

  // Function to handle filtering pipeline runs based on card identifier and execution status code
  const filterPipelineRuns = (
    identifier: string,
    executionStatuCode: number,
  ) => {
    // Dispatch action to toggle the card's active state
    dispatch(cardToggle(identifier))
    // Dispatch action to refresh the filtered status calendar with the selected card's identifier and status code
    dispatch(filterRefreshStatusCalendar({ identifier, executionStatuCode }))
  }

  // Select the active card from the Redux store (which card is currently selected)
  const activeCard = useAppSelector((state) => state.monitor.activeCard)

  return (
    <div>
      <Box
        sx={{
          marginTop: 2,
          display: "flex",
          gap: 1,
          marginLeft: 0,
          padding: 0,
        }}
      >
        {/* Loop through each card and display it */}
        {cards.map((card: IMonitorCardInterface) => {
          return (
            // Each card box has styling based on whether it's active or not
            <Box
              sx={{
                boxShadow:
                  activeCard == card.identifier
                    ? "0px 3px 6px 0px var(--secondary-dp-color)" // Shadow and border styling for the active card
                    : "0px 2px 4px 0px #00000040",
                border:
                  activeCard == card.identifier
                    ? "2px solid var(--primary-dp-color)"
                    : "2px solid #fff", // Active card border
                cursor: "pointer",
                borderRadius: 3,
                flex: 1,
                height: "fit-content",
              }}
              key={card.identifier}
              // When the card is clicked, call filterPipelineRuns with the card's details
              onClick={() =>
                filterPipelineRuns(
                  card.identifier,
                  card.executionStatusCode ? card.executionStatusCode : 0,
                )
              }
            >
              <MonitorCard {...card} pipelines={pipelines} />
            </Box>
          )
        })}
      </Box>

      {/* Gantt chart wrapper to display Gantt charts */}
      <Box className="grid grid-cols-1 gap-4" sx={{ minHeight: 600 }}>
        <div className="p-4 rounded-md bg-white border my-2 rounded-md bg-white pt-0">
          <GantChartWrapper></GantChartWrapper>
        </div>
      </Box>

      {/* Monitoring deep dive section */}
      <div>
        <MonitoringDeepDive />
      </div>

      {/* Dialog for creating a new pipeline */}
      <NewPipeLineDialog></NewPipeLineDialog>
    </div>
  )
}
